const initialState = {
    AllEchClient: [],
  };
  export default function (state = initialState, action) {
    switch (action.type) {
      case "EchRCLI_GET":
        return {
          ...state,
          AllEchClient: action.payload,
        };
      default:
        return state;
    }
  }
  